/**
 * Base Maps Management Page
 * 
 * Admin page for managing base maps.
 */

import React from 'react';
import { Container, SpaceBetween, Header } from '@cloudscape-design/components';
import BaseMapsList from '../../components/admin/BaseMapsList';

const BaseMapsManagement: React.FC = () => {
  return (
    <SpaceBetween size="l">
      <Header
        variant="h1"
        description="Manage base maps for the Print Map Maker. Configure single-tile and multi-tile base maps with projection parameters."
      >
        Base Maps Management
      </Header>

      <Container>
        <BaseMapsList />
      </Container>
    </SpaceBetween>
  );
};

export default BaseMapsManagement;
